class DateFormattable extends Date {
    constructor(dateString, stepDays) {
        var date;
        if (dateString) {
            if (typeof dateString == "string" && dateString.indexOf(" ") > -1) {
                dateString = dateString.split(" ").join("T"); // Converts "2020-20-20 20:20:20 to ISO 8601, for IOS
                date =
                    typeof dateString == "string" ? new Date(dateString) : new Date();
            } else {
                date = new Date(dateString);
            }
        } else {
            date = new Date();
        }
        super(date);

        // Step Days if it exists
        if (stepDays && stepDays !== 0) {
            this.shiftDate(stepDays);
        }
    }

    getTimeDelimited(delimiter = ":") {
        // Assumes date is a javascript date
        return [this.getHours(), this.getMinutes(), this.getSeconds()].join(
            delimiter
        );
    }

    shiftDate(stepDays) {
        this.setDate(this.getDate() + stepDays);
    }

    shiftDateWeekdaysOnly(stepDays) {
        while (stepDays > 0) {
            this.setDate(this.getDate() + 1);
            if (this.getDay() !== 0 && this.getDay() !== 6) {
                stepDays--;
            } else {
            }
        }
    }

    formatDdMonYyyy() {
        // DD Mon YYYY
        return `${this.getDateWithZero()} ${this.getMonthDesc().substring(0,3)} ${this.getFullYear()}`;
    }
    formatMonYyyy() {
        // Mmm YYYY
        return `${this.getMonthDesc().substring(0,3)} ${this.getFullYear()}`;
    }
    formatDayDdMonYyyy() {
        // Day, DD Mon YYYY
        return `${this.getDayDesc().substring(0, 3)},  ${this.getDateWithZero()} ${this.getMonthDesc().substring(
            0,
            3
        )} ${this.getFullYear()}`;
    }
    formatDayMonDdYyyy() {
        // Day, Mon DD YYYY
        return `${this.getDayDesc().substring(0, 3)}, ${this.getMonthDesc().substring(
            0,
            3
        )} ${this.getDateWithZero()} ${this.getFullYear()}`;
    }
    formatDayParMonDdYyyyPar() {
        // Day, Mon DD YYYY
        return `${this.getDayDesc()} (${this.getMonthDesc().substring(
            0,
            3
        )} ${this.getDateWithZero()} ${this.getFullYear()})`;
    }
    formatDayParDdMonYyyyPar() {
        // Day (Mon DD YYYY)
        return `${this.getDayDesc()} (${this.getDateWithZero()} ${this.getMonthDesc().substring(
            0,
            3
        )} ${this.getFullYear()})`;
    }

    getDayDesc() {
        var day = this.getDay();
        switch (day) {
            case 0:
                day = "Sunday";
                break;
            case 1:
                day = "Monday";
                break;
            case 2:
                day = "Tuesday";
                break;
            case 3:
                day = "Wednesday";
                break;
            case 4:
                day = "Thursday";
                break;
            case 5:
                day = "Friday";
                break;
            case 6:
                day = "Saturday";
                break;
        }
        return day;
    }
    getMonthDesc() {
        var month = this.getMonth();
        switch (month) {
            case 0:
                month = "January";
                break;
            case 1:
                month = "February";
                break;
            case 2:
                month = "March";
                break;
            case 3:
                month = "April";
                break;
            case 4:
                month = "May";
                break;
            case 5:
                month = "June";
                break;
            case 6:
                month = "July";
                break;
            case 7:
                month = "August";
                break;
            case 8:
                month = "September";
                break;
            case 9:
                month = "October";
                break;
            case 10:
                month = "November";
                break;
            case 11:
                month = "December";
                break;
        }
        return month;
    }

    getDateWithZero(){
        var date = this.getDate();
        if(date.toString().length == 1){
            date = '0' + date;
        }
        return date
    }
}

module.exports = DateFormattable;
